import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { GrecoRoute } from './route';
import { buildRoute } from './_utils';

@NgModule()
export class GrecoRouterModule {
  private constructor() {
    throw new Error();
  }

  static forRoot(routes: GrecoRoute[]) {
    return RouterModule.forRoot(routes?.map(route => buildRoute(route)));
  }

  static forChild(routes: GrecoRoute[]) {
    return RouterModule.forChild(routes?.map(route => buildRoute(route)));
  }
}
